import { createContext } from "react";

import { getRoutes } from "../../../config";
import type { NavbarContextType } from "../navbar.types";

export const NavbarContext = createContext<NavbarContextType>({
  baseURL: "",
  routes: getRoutes(""),
  user: null,
  onLogout: undefined,
  favoriteVehicles: 0,
  unreadChats: 0,
  guestLinks: [],
  userLinks: [],
  shouldOpenInSameWindow: true,
});
